// Add your custom JS here.

let navbarNavDropdown = document.getElementById("navbarNavDropdown");

if (navbarNavDropdown) {
	navbarNavDropdown.addEventListener("show.bs.collapse", function () {
		document.body.classList.add("menu-visible");
	});

	navbarNavDropdown.addEventListener("hide.bs.collapse", function () {
		document.body.classList.remove("menu-visible");
	});
}

let vh = window.innerHeight * 0.01;
const root = document.documentElement;

function scrollbarVisible() {
    return jQuery(document).height() > jQuery(window).height();
}

jQuery(window).on('resize load scroll', function () {
    if (scrollbarVisible()) {
        root.style.setProperty('--scrollbar-width', (window.innerWidth - root.clientWidth) + "px");
    } else {
        root.style.setProperty('--scrollbar-width', '0px');
    }
    vh = window.innerHeight * 0.01;
    root.style.setProperty('--vh', `${vh}px`);
});

const stickyNav = document.getElementById("main-nav");
const stickyNavHeight = stickyNav ? stickyNav.offsetHeight : 0;

let lastScrollY = window.scrollY;

function handleStickyNav() {
    if (!stickyNav) return;

    const navIsVisible = window.scrollY <= stickyNavHeight;
    const scrollingUp = window.scrollY < lastScrollY;

    if (scrollingUp && !navIsVisible) {
        stickyNav.classList.add("is-sticky");
    } else {
        stickyNav.classList.remove("is-sticky");
        stickyNav.style = '';
    }

    lastScrollY = window.scrollY;
    root.style.setProperty('--sticky-nav-height', `${stickyNavHeight}px`);
}


window.addEventListener("scroll", handleStickyNav);
window.addEventListener("resize", function () {
    handleStickyNav();
});

// Initial check
handleStickyNav();